module.exports = __webpack_public_path__ + "img/Mongolia.623dfb31.gif";